// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  background: #181818;
  /*border-bottom: 1px solid #e5e7eb;*/
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Container styles moved to global index.css */

/* Header layout restructuring */
.proskins-header {
  background: #181818;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.proskins-header .container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 0;
  height: 100%;
}

/* Left section: Logo + Navigation grouped together */
.proskins-header-logo {
  flex: 0 0 auto;
}

/* Navigation - positioned next to logo */
.nav {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 0 0 auto;
}

/* Auth section - right side */
.auth-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 0 0 auto;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(--spacing-lg);
}
.proskins-header .header-content {
  padding: 0 var(--spacing-lg);
}
.logo {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  text-decoration: none;
  transition: color 0.2s ease-in-out;
}

.logo:hover {
  color: #667eea;
}

.nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.nav-link {
  color: #b2b2b2;
  text-decoration: none;
  font-weight: 500;
  font-size: 1.125rem;
  transition: color 0.2s ease-in-out;
  position: relative;
}

.nav-link:hover {
  color: #667eea;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -0.5rem;
  left: 0;
  width: 0;
  height: 2px;
  background: #667eea;
  transition: width 0.2s ease-in-out;
}

.nav-link:hover::after {
  width: 100%;
}

.auth-section {
  display: flex;
  align-items: center;
}

.auth-buttons {
  display: flex;
  gap: 1rem;
}

.user-menu {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-name {
  color: #374151;
  font-weight: 500;
}

/* Button styles moved to components/ui/Button.css */

.loginbtn, .loginbtn:hover {
  background-color: #3ad640;
  border-radius: 0;
  border: none;
  color: #000000;
  text-transform: uppercase;
  padding: 0.5rem 2rem;
  font-family: var(--font-poppins), sans-serif;
  text-decoration: none;
}

.btn-admin {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  color: white;
  border: none;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(240, 147, 251, 0.3);
}

.btn-admin:hover {
  background: linear-gradient(135deg, #e889f1 0%, #f44762 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);
}
.pipecolor{
  color: transparent;
  background: #393939;
  width: 2.5px;
}
.headericon{
  /* height: fit-content; */
  height: 25px;
  margin-top: 7px;
}

/* Header icons container */
.header-icons-container {
  gap: 1rem !important;
}

/* Header icons styling */
.header-icon {
  font-size: 1.5rem !important;
  width: 25px !important;
  height: 25px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  border-radius: 6px !important;
  padding: 4px !important;
}

.header-icon:hover {
  background-color: rgba(58, 214, 64, 0.1) !important;
  transform: scale(1.1) !important;
}
.cursor{
  cursor: pointer;
}

/* Loading spinner styles - use global .loading-spinner and .spinner from proskins-theme.css */
.header-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-spinner {
  width: 1.5rem;
  height: 1.5rem;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

/* Responsive */
@media (max-width: 768px) {
  .nav {
    display: block;
  }
  
  .user-name {
    display: none;
  }
  
  .auth-buttons {
    gap: 0.5rem;
  }
  
  .btn {
    padding: 0.375rem 0.75rem;
    font-size: 0.8125rem;
  }
  .proskins-nav-link{
    padding: 10px;
  }
}

/* Popup */
.open-btn, .close-btn {
  background: #4caf50;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.open-btn:hover, .close-btn:hover {
  background: #45a049;
}

/* Background overlay */
.popup-overlay {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center;     /* Center vertically */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000e8;
  z-index: 9999;
}

/* Popup content */
.popup-content {
  background: #000;
  padding: 20px;
  border-radius: 10px;
  width: auto;
  max-width: 90%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
  animation: popupScale 0.3s ease;
}

/* Close button */
.popup-close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
}

.login_bg{
 float : left;
}


/* Popup animation */
@keyframes popupScale {
  0% { transform: scale(0.8); opacity: 0; }
  100% { transform: scale(1); opacity: 1; }
}

.notifycount{
  color: #000;
  position: relative;
  /* left: 1.5rem;
  top: -1.15rem; */
  left: 1.25rem;
  top: -0.85rem;
  font-size: 0.75rem;
}

/* Welcome text styling */
.welcome-text {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  margin-top: 7px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,wCAAwC;AAC1C;;AAEA,+CAA+C;;AAE/C,gCAAgC;AAChC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oDAAoD;;AAEpD;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,+CAA+C;AACjD;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;;AAEA,8FAA8F;AAC9F;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;IACzB,oBAAoB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB,EAAE,wBAAwB;EACjD,mBAAmB,MAAM,sBAAsB;EAC/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;CACC,YAAY;AACb;;;AAGA,oBAAoB;AACpB;EACE,KAAK,qBAAqB,EAAE,UAAU,EAAE;EACxC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB;kBACgB;EAChB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;AACjB","sourcesContent":[".header {\n  background: #181818;\n  /*border-bottom: 1px solid #e5e7eb;*/\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Container styles moved to global index.css */\n\n/* Header layout restructuring */\n.proskins-header {\n  background: #181818;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.proskins-header .container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 0;\n  height: 100%;\n}\n\n/* Left section: Logo + Navigation grouped together */\n.proskins-header-logo {\n  flex: 0 0 auto;\n}\n\n/* Navigation - positioned next to logo */\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  flex: 0 0 auto;\n}\n\n/* Auth section - right side */\n.auth-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex: 0 0 auto;\n}\n\n.header-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 var(--spacing-lg);\n}\n.proskins-header .header-content {\n  padding: 0 var(--spacing-lg);\n}\n.logo {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #111827;\n  text-decoration: none;\n  transition: color 0.2s ease-in-out;\n}\n\n.logo:hover {\n  color: #667eea;\n}\n\n.nav {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.nav-link {\n  color: #b2b2b2;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 1.125rem;\n  transition: color 0.2s ease-in-out;\n  position: relative;\n}\n\n.nav-link:hover {\n  color: #667eea;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: -0.5rem;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: #667eea;\n  transition: width 0.2s ease-in-out;\n}\n\n.nav-link:hover::after {\n  width: 100%;\n}\n\n.auth-section {\n  display: flex;\n  align-items: center;\n}\n\n.auth-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.user-menu {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.user-name {\n  color: #374151;\n  font-weight: 500;\n}\n\n/* Button styles moved to components/ui/Button.css */\n\n.loginbtn, .loginbtn:hover {\n  background-color: #3ad640;\n  border-radius: 0;\n  border: none;\n  color: #000000;\n  text-transform: uppercase;\n  padding: 0.5rem 2rem;\n  font-family: var(--font-poppins), sans-serif;\n  text-decoration: none;\n}\n\n.btn-admin {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n  color: white;\n  border: none;\n  font-weight: 600;\n  box-shadow: 0 2px 8px rgba(240, 147, 251, 0.3);\n}\n\n.btn-admin:hover {\n  background: linear-gradient(135deg, #e889f1 0%, #f44762 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(240, 147, 251, 0.4);\n}\n.pipecolor{\n  color: transparent;\n  background: #393939;\n  width: 2.5px;\n}\n.headericon{\n  /* height: fit-content; */\n  height: 25px;\n  margin-top: 7px;\n}\n\n/* Header icons container */\n.header-icons-container {\n  gap: 1rem !important;\n}\n\n/* Header icons styling */\n.header-icon {\n  font-size: 1.5rem !important;\n  width: 25px !important;\n  height: 25px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  cursor: pointer !important;\n  transition: all 0.3s ease !important;\n  border-radius: 6px !important;\n  padding: 4px !important;\n}\n\n.header-icon:hover {\n  background-color: rgba(58, 214, 64, 0.1) !important;\n  transform: scale(1.1) !important;\n}\n.cursor{\n  cursor: pointer;\n}\n\n/* Loading spinner styles - use global .loading-spinner and .spinner from proskins-theme.css */\n.header-loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header-spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border: 2px solid #e5e7eb;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .nav {\n    display: block;\n  }\n  \n  .user-name {\n    display: none;\n  }\n  \n  .auth-buttons {\n    gap: 0.5rem;\n  }\n  \n  .btn {\n    padding: 0.375rem 0.75rem;\n    font-size: 0.8125rem;\n  }\n  .proskins-nav-link{\n    padding: 10px;\n  }\n}\n\n/* Popup */\n.open-btn, .close-btn {\n  background: #4caf50;\n  color: white;\n  padding: 10px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.open-btn:hover, .close-btn:hover {\n  background: #45a049;\n}\n\n/* Background overlay */\n.popup-overlay {\n  display: flex;\n  justify-content: center; /* Center horizontally */\n  align-items: center;     /* Center vertically */\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #000000e8;\n  z-index: 9999;\n}\n\n/* Popup content */\n.popup-content {\n  background: #000;\n  padding: 20px;\n  border-radius: 10px;\n  width: auto;\n  max-width: 90%;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  position: relative;\n  animation: popupScale 0.3s ease;\n}\n\n/* Close button */\n.popup-close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.login_bg{\n float : left;\n}\n\n\n/* Popup animation */\n@keyframes popupScale {\n  0% { transform: scale(0.8); opacity: 0; }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n.notifycount{\n  color: #000;\n  position: relative;\n  /* left: 1.5rem;\n  top: -1.15rem; */\n  left: 1.25rem;\n  top: -0.85rem;\n  font-size: 0.75rem;\n}\n\n/* Welcome text styling */\n.welcome-text {\n  color: #ffffff;\n  font-size: 1rem;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  margin-top: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
